import React from 'react';
import Croppie from 'croppie';
import PropTypes from 'prop-types';
/* Styles */
import 'croppie/croppie.css';

const croppieOptions = {
  mouseWheelZoom: false,
  boundary: {
    width: 400,
    height: 400,
  },
  viewport: {
    width: 200,
    height: 200,
    type: 'circle',
  },
};

class ImageCropper extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    if (this.ref) {
      this.c = new Croppie(this.ref, croppieOptions);
      this.c.bind({
        url: this.props.imageSource,
      });
    }
  }

  handleSave = () => {
    this.c.result({type: 'base64'}).then((data) => {
      this.props.handleCrop(data);
    });
  };

  render() {
    return (
      <>
        <div className="glu-modal__header glu-flex glu-flex-align-center">
          <div className="glu-modal__title glu-flex-grow">Crop Image</div>
          <div className="glu-flex-shrink">
            <button
              aria-label="close"
              type="button"
              className="glu-btn-link g-icon g-icon-close"
              onClick={this.props.handleCancel}
            />
          </div>
        </div>
        <div className="glu-modal__body">
          <div className="glu-content__section">
            Click-and-drag or zoom to optimize the dashboard image.
          </div>
          <div className="glu-content__section">
            <div
              id="crop"
              ref={(el) => {
                this.ref = el;
              }}
            />
          </div>
        </div>
        <footer className="glu-modal__footer">
          <div className="glu-flex-grow glu-flex-row">
            <div className="glu-flex-grow text-right">
              <button
                type="button"
                onClick={this.props.handleCancel}
                className="glu-btn glu-btn--secondary"
              >
                Cancel
              </button>
            </div>
            <div className="glu-flex-shrink">
              <button type="button" onClick={this.handleSave} className="glu-btn glu-btn--primary">
                Add
              </button>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

ImageCropper.propTypes = {
  imageSource: PropTypes.string,
  handleCrop: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

ImageCropper.defaultProps = {
  imageSource: '',
};

export default ImageCropper;
